import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { GamificationService, SmartScoreSummary } from '../../../services/gamification.service';
import {
  DIMENSION_ORDER,
  DIMENSIONS,
  PointDimension
} from '../../gamification/smart-score.utils';
import { SmartScoreModalComponent } from '../smart-score-modal/smart-score-modal.component';
import { GiveKarmaModalComponent } from '../give-karma-modal/give-karma-modal.component';

@Component({
  selector: 'app-smart-score-widget',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './smart-score-widget.component.html',
  styleUrls: ['./smart-score-widget.component.css']
})
export class SmartScoreWidgetComponent implements OnInit, OnDestroy {
  @Input() variant: 'header' | 'drawer' = 'header';

  summary: SmartScoreSummary | null = null;

  readonly dimensionOrder = DIMENSION_ORDER;
  readonly dimensions = DIMENSIONS;

  private readonly gamification = inject(GamificationService);
  private sub?: Subscription;

  ngOnInit(): void {
    this.sub = this.gamification.summary$.subscribe(summary => (this.summary = summary));
    void this.gamification.refresh();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  valueFor(key: PointDimension): number {
    const s = this.summary;
    if (!s) {
      return 0;
    }
    if (key === 'vitalis') {
      return s.vitalis;
    }
    if (key === 'pulse') {
      return s.pulse;
    }
    return s.karmaReceived;
  }

  openBreakdown(): void {
    this.gamification.openBreakdown();
  }
}
